import { IMunicipalityEntity } from '../interfaces/IMunicipalityEntity'

export const municipalityToLabel = (municipality: IMunicipalityEntity): string =>
  `[${municipality.kuKod}] ${municipality.kuNazev} (${municipality.obecNazev}, ${municipality.krajNazev})`
